import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMap = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m17.582 11.75.453 2.813c.204 1.27.306 1.906.11 2.4a2.028 2.028 0 0 1-.921 1.026c-.481.261-1.153.261-2.497.261H5.273c-1.344 0-2.016 0-2.497-.261a2.028 2.028 0 0 1-.92-1.026c-.197-.494-.095-1.13.11-2.4l.452-2.813m10.94-1.868a4.773 4.773 0 0 0 0-6.737 4.74 4.74 0 0 0-6.717 0 4.773 4.773 0 0 0 0 6.737L10 13.25l3.359-3.368ZM10.75 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
	})]
});
const ForwardRef = forwardRef(SvgMap);
export { ForwardRef as ReactComponent };
